import { render, staticRenderFns } from "./ActionsLog.vue?vue&type=template&id=2ae2b4e3&scoped=true&"
import script from "./ActionsLog.vue?vue&type=script&lang=js&"
export * from "./ActionsLog.vue?vue&type=script&lang=js&"
import style0 from "./ActionsLog.vue?vue&type=style&index=0&id=2ae2b4e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2b4e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
